import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";

const Container = styled.div({
  position: "relative",
  width: "100%",
});

const IconBox = styled.div({
  position: "absolute",
  top: "50%",
  left: "2rem",
  transform: "translate(0,-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const SearchInputBox = styled.input<{
  backgroundColor?: string;
  noIcon?: boolean;
}>(({ theme, backgroundColor }) => ({
  width: "100%",
  height: "6rem",
  padding: "1rem 2rem 1rem 5rem",
  fontSize: "1.6rem",
  borderRadius: "10px",
  lineHeight: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  border: "none",
  textAlign: "start",
  backgroundColor: backgroundColor || theme.color.border_gray,
  color: theme.color.black,

  "::placeholder": {
    color: theme.color.gray,
    fontWeight: theme.fontWeight.medium,
  },
}));

type Props = {
  inputValue: string;
  setInputValue: (value: string) => void;
  placeholder?: string;
  onClick?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  backgroundColor?: string;
};
const SearchInput = ({
  placeholder = "검색",
  inputValue,
  setInputValue,
  onClick,
  disabled,
  backgroundColor,
}: Props) => {
  const theme = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setInputValue(value);
  };

  return (
    <Container>
      <SearchInputBox
        type="text"
        onChange={handleChange}
        value={inputValue}
        placeholder={placeholder}
        onKeyUp={onClick}
        disabled={disabled}
        backgroundColor={backgroundColor}
      />

      <IconBox>
        <Image
          src={theme.image.search_icon.default}
          width="2.5rem"
          height="2.5rem"
        />
      </IconBox>
    </Container>
  );
};

export default SearchInput;
